import { ActionGuard } from '@src/components/permissions';
import { Button } from '@src/components';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import { EffectivePermissions } from '@src/services/users/myPermissions/myPermissionsApiSliceTypes';

interface ProtectedButtonProps {
    module: keyof EffectivePermissions;
    labelKey: string;
    className?: string;
    icon?: ReactNode;
    onClick: () => void;
}

export const ProtectedButton = ({
    module,
    labelKey,
    className = 'btn-primary',
    icon,
    onClick,
}: ProtectedButtonProps) => {
    const { t } = useTranslation();

    return (
        <ActionGuard module={module}>
            <Button
                size="large"
                icon={icon}
                onClick={onClick}
                className={className}
            >
                <span className="text-M-16">{t(labelKey)}</span>
            </Button>
        </ActionGuard>
    );
};
